import Konva from 'konva';
import React from 'react';
import { Rect } from 'react-konva';
import useImage from 'use-image';

interface Props {
	rectProps: any;
}

const Rects: React.FC<Props> = ({ rectProps }) => {
	const rectRef = React.useRef<Konva.Rect>(null);

	const rawPatternUrl = typeof rectProps?.fillPatternImage === 'string'
		? rectProps.fillPatternImage
		: rectProps?.fillPatternUrl;

	const [safePatternImage] = useImage(rawPatternUrl || '');

	const safeProps = { ...rectProps };
	if (rawPatternUrl && safePatternImage) {
		safeProps.fillPatternImage = safePatternImage;
	} else if (rawPatternUrl && !safePatternImage) {
		safeProps.fillPatternImage = undefined;
	}

	return <Rect ref={rectRef} {...safeProps} draggable={false} />;
};
export default Rects;
